document.addEventListener('DOMContentLoaded', () => {
  // サイズ表示順をもとに、テーブルをソート
  const updateTableWithSortedItems = (tableId, itemsClass) => {
    const table = document.querySelector(tableId);
    let templateString = '';
    const items = Array.from(document.querySelectorAll(itemsClass));

    items
      .sort((a, b) => {
        const aValue = a.dataset.order ? Number(a.dataset.order) : 999999;
        const bValue = b.dataset.order ? Number(b.dataset.order) : 999999;
        return aValue - bValue;
      })
      .forEach(item => (templateString += item.outerHTML));

    table.innerHTML = templateString;
  };

  // PCとSPそれぞれのテーブルをソート
  updateTableWithSortedItems('#productSizeTable', '.productDetail__info__size__table__size');
  updateTableWithSortedItems('#productSizeTableSp', '.productDetail__info__size__table__sizeSp');
});
